module.exports = __webpack_public_path__ + "static/media/coin_stack_level_4.7d4792dd.svg";